import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-section">
            <h4>FreakMe.Fun</h4>
            <ul>
              <li><Link to="/about">{t('footer.about')}</Link></li>
              <li><Link to="/careers">{t('footer.careers')}</Link></li>
              <li><Link to="/press">{t('footer.press')}</Link></li>
              <li><Link to="/blog">{t('footer.blog')}</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><Link to="/help">{t('footer.help')}</Link></li>
              <li><Link to="/contact">{t('footer.contact')}</Link></li>
              <li><Link to="/safety">{t('footer.safety')}</Link></li>
              <li><Link to="/faq">{t('footer.faq')}</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/terms">{t('footer.terms')}</Link></li>
              <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
              <li><Link to="/cookies">{t('footer.cookies')}</Link></li>
              <li><Link to="/dmca">{t('footer.dmca')}</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Community</h4>
            <ul>
              <li><Link to="/become-model">{t('footer.become_model')}</Link></li>
              <li><Link to="/partners">{t('footer.partners')}</Link></li>
              <li><Link to="/affiliates">{t('footer.affiliates')}</Link></li>
              <li><Link to="/advertise">{t('footer.advertise')}</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>{t('footer.rights', { year: currentYear })}</p>
          <div className="social-links">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">𝕏</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">📷</a>
            <a href="https://discord.com" target="_blank" rel="noopener noreferrer" aria-label="Discord">💬</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
